import protectedData from './system-protected-data.svg?url';

const ROOT_PATH = 'https://static.sfox.au/images/';

export const IMAGE_MAP = {
	ProtectedData: protectedData,
	NoData: `${ROOT_PATH}system_no-data.svg`,
	EmptyProfile: `${ROOT_PATH}system_empty-profile.svg`,
	CirclesOrganise: `${ROOT_PATH}circles_organise.svg`,
	RecordNotFound: `${ROOT_PATH}system_missing-record.svg`,
	MissingChat: `${ROOT_PATH}system_missing-chat.svg`,
	Error01: `${ROOT_PATH}Error_Sim_01.lottie`,
	Error02: `${ROOT_PATH}Error_Sim_02.lottie`,
	Error03: `${ROOT_PATH}Error_Sim_03.lottie`,
	Error04: `${ROOT_PATH}Error_Sim_04.lottie`,
	Error05: `${ROOT_PATH}Error_Sim_05.lottie`,
	Error06: `${ROOT_PATH}Error_Sim_06.lottie`
} as const;

export type EmptyStateImage = keyof typeof IMAGE_MAP;

export const ERROR_IMAGES = (Object.keys(IMAGE_MAP) as EmptyStateImage[]).filter(key => key.startsWith('Error'));

export const isLottieFile = (url: string) => url.endsWith('.lottie');

export enum EmptyStateSize {
	XLarge = 'xlarge',
	Large = 'large',
	Medium = 'medium',
	Small = 'small'
}
